import AccountSettingsPage from "./pages/AccountSettingsPage";
import ChatPage from "./pages/ChatPage";
import CreatePainEntryPage from "./pages/CreatePainEntryPage";
import DashboardPage from "./pages/DashboardPage";
import MyOrdersPage from "./pages/MyOrdersPage";
import OrderCream from "./pages/OrderCream";
import PaymentPage from "./pages/PaymentPage";
import UserSingleOrderPage from "./pages/UserSingleOrderPage";
import OrderTrackingPg from "./pages/OrderTracking";

const routesList: Array<IRoute> = [
  {
    path: "/",
    Component: DashboardPage,
    roles: ["ADMIN"],
    text: "Dashboard",
    show: true,
    Icon: "",
  },
  {
    path: "/create-pain-entry",
    Component: CreatePainEntryPage,
    roles: ["ADMIN"],
    text: "Create Pain Entry",
    show: true,
    Icon: "",
  },
  {
    path: "/order-cream",
    Component: OrderCream,
    roles: ["ADMIN"],
    text: "Order Twinge Cream",
    show: true,
    Icon: "",
  },
  {
    path: "/order-tracking",
    Component: OrderTrackingPg,
    roles: ["ADMIN"],
    text: "Order Tracking",
    show: true,
    Icon: "",
  },
  {
    path: "/auth/account-settings",
    Component: AccountSettingsPage,
    roles: ["ADMIN"],
    text: "Account Settings",
    show: false,
    Icon: "",
  },
  {
    path: "/chat",
    Component: ChatPage,
    roles: ["ADMIN"],
    text: "Chat",
    show: false,
    Icon: "",
  },
  {
    path: "/orders",
    Component: MyOrdersPage,
    roles: ["ADMIN"],
    text: "Orders",
    show: true,
    Icon: "",
  },
  {
    path: "/order-details/:orderId",
    Component: UserSingleOrderPage,
    roles: ["ADMIN"],
    text: "Orders",
    show: false,
    Icon: "",
  },
  {
    path: "/payment",
    Component: PaymentPage,
    roles: ["ADMIN"],
    text: "Payment",
    show: true,
    Icon: "",
  },
];
export const AppRoutes = () => {
  //   const filterRoutes = (routes: IRoute[]): IRoute[] => {
  //    return routes;
  //   };

  return routesList; // filterRoutes(routesList);
};
